/**
 * Debug utilities for development environment
 */

import { env } from './environment';

/**
 * Client-side debug information that's safe to use in browser
 */
export function getClientDebugInfo() {
  return {
    environment: env.environment,
    isDevelopment: env.isDevelopment,
    isProduction: env.isProduction,
    isDebugMode: env.isDebugMode,
    firebaseProjectId: env.firebaseProjectId,
    shouldUseFirebaseEmulators: env.shouldUseFirebaseEmulators,
    apiBaseUrl: env.apiBaseUrl,
    // Safe to expose these NEXT_PUBLIC_ variables
    clientEnvVars: {
      NEXT_PUBLIC_APP_ENV: process.env.NEXT_PUBLIC_APP_ENV,
      NEXT_PUBLIC_USE_FIREBASE_EMULATOR: process.env.NEXT_PUBLIC_USE_FIREBASE_EMULATOR,
      NEXT_PUBLIC_DEBUG_MODE: process.env.NEXT_PUBLIC_DEBUG_MODE,
      NEXT_PUBLIC_FIREBASE_PROJECT_ID: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
    },
  };
}

/**
 * Log debug information in development
 */
export function logDebugInfo() {
  if (env.isDevelopment && typeof window !== 'undefined') {
    const info = getClientDebugInfo();
    console.group('🔍 Environment Debug Info');
    console.table(info.clientEnvVars);
    console.log('Environment Config:', {
      environment: info.environment,
      usingEmulators: info.shouldUseFirebaseEmulators,
      debugMode: info.isDebugMode,
      projectId: info.firebaseProjectId,
    });
    console.groupEnd();
  }
}

/**
 * Global debug function for browser console
 */
if (typeof window !== 'undefined') {
  (window as Window & { debugJayouz?: () => unknown }).debugJayouz = () => {
    const info = getClientDebugInfo();
    console.log('Jayouz Debug Info:', info);
    return info;
  };
}
